import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import { getWatermarkTag } from '../shared';
import SharedUploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  type: 'left' | 'right';
  settings?: boolean;
}

const VariationLRFulltextUploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
  type,
  settings,
}) => {
  // the divider only exists for the left image — see SettingsModal
  const settingsApplied = Boolean(
    (type === 'left' && image.divider !== 'black') ||
      image.brakes ||
      !image.quotes ||
      getWatermarkTag(image) !== 'none',
  );

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showSettings={settings}
      settingsApplied={settingsApplied}
      settingsModal={
        settings ? (
          <SettingsModal
            image={image}
            imageIndex={imageIndex}
            setImages={setImages as any}
            type={type}
            onClose={() => {}}
          />
        ) : undefined
      }
    />
  );
};

export default memo(VariationLRFulltextUploadedImageRow);
